import { render, staticRenderFns } from "./related.vue?vue&type=template&id=32ca8266&"
import script from "./related.vue?vue&type=script&lang=js&"
export * from "./related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports